

































































































































































































































































































































































































































import Vue from "vue";
import moment from "moment";
import downlaod from "downloadjs";
import { date, event, QTab, QTable } from "quasar";
import {
  ConsentsClient,
  ConsentsFilter,
  DailyCustomerConsentAggregate,
  DocumentCompileAndDownloadClient,
  EntityConsent,
  EntityConsentsGroup,
  EntitySelectItem,
} from "@/api/open-api";
import DailyCustomerConsentAggregateDocumentConsentsVue from "./DailyCustomerConsentAggregateDocumentConsents.vue";
import RadioFilter from "../consents-filters/RadioFilter.vue";
import TextFilter from "../consents-filters/TextFilter.vue";
import DecimalFilter from "../consents-filters/DecimalFilter.vue";
import EmptyFilter from "../consents-filters/EmptyTypeFilter.vue";

type QTablePagination = QTable["pagination"];
interface Data {
  showDates: boolean;
  timerSearch: number;
  consentsList: Array<ConsentsFilter>;
  consentsClient: ConsentsClient;
  filterInput: string;
  intervalId: number;
  expanded: string[];
  loading: boolean;
  table: QTable;
  isShow: boolean;
  key: string;
  consents: {
    [consentDefinitionId: number]: {
      responseDefinitionId?: number;
      from?: string;
      to?: string;
      responseDescription?: string;
    };
  };
  timerStopped: boolean;
  filters: {
    ougs: {
      selected: EntitySelectItem | null;
      total: EntitySelectItem[];
      filtered: EntitySelectItem[];
    };
  };
  compareFileDateFrom: string;
  compareFileDateTo: string;
  ougConsentsGroups: Array<EntityConsentsGroup>;
  ConsentsFilters: Array<ConsentsFilter>;
}
export default Vue.extend({
  name: "c-daily-customer-consent-aggregate",
  components: {
    "c-daily-customer-consent-aggregate-document-consents":
      DailyCustomerConsentAggregateDocumentConsentsVue,
    "c-radio-filter": RadioFilter,
    "c-text-filter": TextFilter,
    "c-decimal-filter": DecimalFilter,
    "c-empty-filter": EmptyFilter,
  },
  data(): Data {
    const data = {
      showDates: false,
      dateFrom: "",
      dateTo: "",
      consents: {},
      key: "",
      removeRadio: "grey-6",
      consentsClient: new ConsentsClient(undefined, {
        fetch: function (input: RequestInfo, init?: RequestInit) {
          if (!init) {
            init = { headers: new Headers() };
          }
          if (!init.headers) {
            init.headers = new Headers();
          }

          (init.headers as any).Authorization =
            Vue.prototype.$persistency.getItem("accessToken");

          return fetch(input, init);
        },
      }),
      consentsList: [],
      timerStopped: false,
      filterInput: "",
      intervalId: 0,
      isShow: false,
      group: null,
      loading: false,
      ConsentsFilters: [],
      timerSearch: 0,
      compareFileDateFrom: "",
      compareFileDateTo: "",
      filters: {
        ougs: {
          selected: null,
          total: [],
          filtered: [],
          onFilter(val: string, update: Function) {
            const needle = val.toLowerCase();
            data.filters.ougs.filtered = data.filters.ougs.total.filter(
              (x) => (x.description ?? "").toLowerCase().indexOf(needle) > -1
            );
            update();
          },
        },
      },
      ougConsentsGroups: [],
      expanded: [] as string[],
      table: {
        columns: [
          {
            name: "customerDescription",
            field: "customerDescription",
            label: "Cliente",
            required: true,
            align: "left",
            sortable: true,
          },
          {
            name: "customerAddress",
            field: "customerAddress",
            label: "Indirizzo",
            required: true,
            align: "left",
          },
          {
            name: "customerTaxCode",
            field: "customerTaxCode",
            label: "Codice fiscale / Partita IVA",
            required: true,
            align: "left",
          },
          {
            name: "producer",
            label: "Intermediario",
            align: "left",
            field: (row: DailyCustomerConsentAggregate) =>
              `${row.producerCode}\n${row.producerDescription}`,
          },
          {
            name: "systemFieldTypeValue",
            label: "",
            align: "left",
            field: (row: DailyCustomerConsentAggregate) => {
              let field = "";

              for (const documentConsent of row.documentConsents ?? []) {
                for (const consent of documentConsent.consents ?? []) {
                  if (consent.responseDescription) {
                    if (consent.systemFieldType === "policyNumber") {
                      field += consent.responseDescription + " ";
                    } else if (consent.systemFieldType === "mandate") {
                      field += consent.mandateCompanyDescription + " ";
                    }
                  }
                }
              }

              return field.trimEnd();
            },
          },
          {
            name: "date",
            field: "date",
            label: "Data",
            required: true,
            align: "left",
            format: (dateString: string) => moment(dateString).format("L"),
          },
        ],

        pagination: {
          page: 1,
          rowsPerPage: 10,
          rowsNumber: 10,
        },
        filter: "",
        data: [] as DailyCustomerConsentAggregate[],
      } as QTable,
    } as Data;

    return data;
  },

  methods: {
    // restartTimer() {
    //   this.timerSearch = 10;
    // },

    stopTimer() {
      this.timerSearch = 0;
      clearInterval(this.intervalId);
    },

    changeProgress() {
      const trimmedFilterInput = this.filterInput.replace(/\s/g, "");
      if (trimmedFilterInput.length === 0) {
        this.stopTimer();
        return;
      }

      if (!(this.timerSearch >= 100)) {
        this.timerSearch = this.timerSearch + 0.3;
      } else {
        this.stopTimer();
        this.refresh();
      }
    },

    getKey(event: any) {
      this.key = event.code;
    },

    automaticSearch() {
      this.stopTimer();
      if (this.key === "Enter" || this.timerStopped === true) {
        this.timerStopped = false;
        this.stopTimer();
        this.refresh();
        return;
      }
      const intervalTime = 100;
      this.intervalId = setInterval(this.changeProgress, intervalTime);
    },

    getFilterNumber() {
      let count = this.consentsList.length;
      if (this.filters.ougs.selected != null) count += 1;
      return count;
    },

    getConsentsFilters() {
      this.consentsList = [];

      for (const key in this.consents) {
        const val = this.consents[key] as any;

        if (
          val.ResponseDefinitionId != null ||
          (val.from != null && val.from !== "") ||
          (val.to != null && val.to !== "") ||
          (val.responseDescription != null && val.responseDescription !== "")
        ) {
          this.consentsList.push({
            consentDefinitionId: parseInt(key),
            response: this.consents[key] as any,
          });
        } else {
          this.consentsFilterClearGestor(key);
        }
      }
      return this.consentsList;
    },

    consentsFilterClearGestor(key: any) {
      if (this.consents[key]?.from === "") {
        delete this.consents[key].from;
      }

      if (this.consents[key]?.to === "") {
        delete this.consents[key].to;
      }

      delete this.consents[key];
      this.getConsentsFilters();
    },

    async onPaginationRequest(event: {
      pagination: QTablePagination;
      filter?: string;
    }) {
      this.loading = true;
      this.timerSearch = 0;
      debugger;
      this.table.pagination!.rowsNumber =
        await this.consentsClient.dailyCustomerConsentAggregatesCount({
          organizationalUnitGroupId: this.filters.ougs.selected?.id || null,
          filter: this.filterInput || null,
          pageNumber: event.pagination?.page || 1,
          pageSize: event.pagination?.rowsPerPage || 10,
          consentsFilters: this.getConsentsFilters(),
          dateFrom : moment(this.compareFileDateFrom),
          dateTo : moment(this.compareFileDateTo)
        });

      const dailyCustomerConsentAggregatesResult =
        await this.consentsClient.dailyCustomerConsentAggregates({
          organizationalUnitGroupId: this.filters.ougs.selected?.id || null,
          filter: event.filter || null,
          pageNumber: event.pagination?.page || 1,
          pageSize: event.pagination?.rowsPerPage || 10,
          consentsFilters: this.getConsentsFilters(),
          dateFrom : moment(this.compareFileDateFrom),
          dateTo : moment(this.compareFileDateTo)
        });

      this.table.filter = this.filterInput;
      this.filters.ougs.total =
        dailyCustomerConsentAggregatesResult.linkedOugs ?? [];

      this.filters.ougs.filtered = this.filters.ougs.total;

      let selected: number | undefined | null = null;
      if (this.filters.ougs.total.length === 1) {
        selected = this.filters.ougs.total[0]?.id;
      } else {
        selected = this.filters.ougs.selected?.id;
      }

      this.table.data = dailyCustomerConsentAggregatesResult.items ?? [];
      this.loading = true;
      this.table.pagination!.page = event.pagination!.page;
      this.table.pagination!.rowsPerPage = event.pagination!.rowsPerPage;
      this.table.pagination!.sortBy = event.pagination!.sortBy;
      this.table.pagination!.descending = event.pagination!.descending;

      this.loading = false;

      this.ougConsentsGroups =
        (await this.consentsClient.customerDocumentConsentDefinitionGroups(
          selected
        )) || [];
    },

    resetFiltersOnChangeOug() {
      
      if(this.showDates)
        this.showDates = false;
      else
        this.showDates = true;

      this.consents = {};
      const qTable = this.$refs.table as QTable;
      if (qTable) {
        qTable.requestServerInteraction();
      }
    },
    removeSelections() {
      this.consents = {};
      this.getConsentsFilters();
    },

    getRowKey(row: DailyCustomerConsentAggregate) {
      return JSON.stringify(row);
    },

    toggleFilter() {
      return (this.isShow = !this.isShow);
    },
    expandAll() {
      this.expanded =
        this.table?.data?.map((item: DailyCustomerConsentAggregate) =>
          this.getRowKey(item)
        ) ?? [];
    },
    refresh() {
      const qTable = this.$refs.table as QTable;
      if (qTable) {
        qTable.requestServerInteraction();
      }
      this.loading = false;
    },
   },

  async mounted() {
    this.refresh();
  },
});
